import { render, staticRenderFns } from "./PaginationEditor.vue?vue&type=template&id=9ccc2168"
import script from "./PaginationEditor.vue?vue&type=script&lang=js"
export * from "./PaginationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports